import styled from 'styled-components';

const ContentStyle = styled.div`
    color: ${(props) => props.theme.colors.white};
    margin: 0 auto;
    max-width: 900px;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
`;

export { ContentStyle };
